export const removeLeadingZeros = (str: string) => {
	return str.replace(/^0+/, '') || '0';
}